// utils/base64ToFile.js
export function sanitizeBase64(input) {
  if (!input) return '';

  // 1) Если пришёл data URL — отрезаем префикс
  const m = /^data:([\w/+.-]+);base64,(.*)$/i.exec(input);
  let b64 = m ? m[2] : input;

  // 2) Если пришёл PEM/CMS с заголовками — вырежем их
  // -----BEGIN ...----- / -----END ...-----
  if (/-----BEGIN[\s\S]+?-----/.test(b64)) {
    b64 = b64
      .replace(/-----BEGIN[\s\S]+?-----/g, '')
      .replace(/-----END[\s\S]+?-----/g, '');
  }

  // 3) Удалим все пробелы/переносы
  b64 = b64.replace(/\s+/g, '');

  // 4) Преобразуем URL-safe base64 в стандартный
  b64 = b64.replace(/-/g, '+').replace(/_/g, '/');

  // 5) Допроставим паддинг до кратности 4
  const pad = b64.length % 4;
  if (pad === 2) b64 += '==';
  else if (pad === 3) b64 += '=';
  else if (pad === 1) {
    // Совсем битая строка
    throw new Error('Invalid base64 length (mod 4 = 1)');
  }

  return b64;
}

export function sanitizeBase64Pdf(b64) {
  if (!b64) return '';
  // убрать data:... префикс, если вдруг есть
  b64 = b64.replace(/^data:application\/pdf;base64,?/i, '');
  // убрать перевод строк/пробелы
  b64 = b64.replace(/\s+/g, '');
  return b64;
}

export function base64ToFile(base64, filename = 'file.bin', mime = 'application/octet-stream') {
  const b64 = sanitizeBase64(base64);

  // Декодируем
  let binary;
  try {
    binary = atob(b64);
  } catch (e) {
    console.error('Invalid base64 for atob:', e);
    throw e; // важно пробросить, чтобы вы это увидели в catch
  }

  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);

  try {
    return new File([bytes], filename, { type: mime });
  } catch {
    // Safari до недавнего времени не поддерживал File в некоторых контекстах
    return new Blob([bytes], { type: mime });
  }
}
